import React from "react";
import Spinner from "react-bootstrap/Spinner";

const LoadingIndicator = ({ size, padding }) => {
  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        justifyContent: "center",
        padding: padding || "20px",
      }}
    >
      <Spinner size={size} animation="border" role="status"></Spinner>
    </div>
  );
};

export default LoadingIndicator;
